<!--
 * @Description: 受理进度
--> 
<template>
  <div class="online-progress">
    <van-tabs color="#1677FF" v-model="active" @change="onChange" sticky>
      <van-tab v-for="(tab, i) in tabs" :key="i" :title="tab.title">
        <div class="tab-content">
          <div class="comm-search-bar">
            <div class="bar-con">
              <van-field style="width:100%;" label="业务类型" readonly clickable name="picker" :value="typeName" placeholder="点击选择业务类型" @click="showPicker = true">
                <template #right-icon>
                  <span class="iconfont iconxuanzesanjiao"></span>
                </template>
              </van-field>
            </div>
          </div>
          <div class="comm-seperator"></div>
          <div class="progress-info" v-for="(progress, i) in progressList" :key="i">
            <div class="info-top-wrapper">
              <div class="info-top">
                <div class="info-name">业务类型：</div>
                <div class="info-value">{{progress.busstype}}</div>
              </div>
              <div class="info-top">
                <div class="info-name">受理编号：</div>
                <div class="info-value">{{progress.bussno}}</div>
              </div>
              <div class="info-top">
                <div class="info-name">提交时间：</div>
                <div class="info-value">{{progress.adddate}}</div>
              </div>
              <div class="info-top">
                <div class="info-name">状态：</div>
                <div class="info-value">
                  <van-button plain round size="small" type="default" color="#FF0000" style="width:63px;height:20px;">
                    {{progress.status}}
                  </van-button>
                  <div>
                    <van-button v-if="progress.status==='处理中'" class="comm-small-btn" native-type="button" @click="showClick(progress)" style="height:20px;margin-right:5px;">
                      查看
                    </van-button>
                    <van-button v-if="progress.status==='已退回'" class="comm-small-btn2" native-type="button" @click="rewriteClick(progress)" style="height:20px;margin-right:5px;">
                      重填
                    </van-button>
                    <van-button v-if="progress.status==='已退回'" class="comm-small-btn3" native-type="button" @click="abandonClick(progress)" style="height:20px;">
                      放弃
                    </van-button>
                  </div>

                </div>
              </div>
            </div>
            <div v-show="false" class="info-bottom-wrapper">
              <div class="bottom-title">
                未缴费清单（<span style="color:#2C82C9">2笔</span>）
              </div>
              <div class="bottom-info">
                <div class="bottom-name">工程基准费：</div>
                <div class="bottom-value">
                  <span style="color:#FF0000">1300.00</span>&nbsp;元
                </div>
              </div>
              <div class="bottom-info">
                <div class="bottom-name">工程材料费：</div>
                <div class="bottom-value">
                  <span style="color:#FF0000">300.00</span>&nbsp;元
                </div>
              </div>
            </div>
            <div v-show="false" class="code">
              <div class="code-img">
                <img>
              </div>
              <div class="code-txt">微信、支付宝扫码缴费</div>
            </div>
          </div>
          <div style="height:17px;"></div>
          <div v-if="!progressList||progressList.length===0" style="text-align:center;">
            <img style="width:200px;" :src="require('../../assets/images/no-data.png')">
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'OnlineProgress',
  components: {
  },
  props: {
    typeCode: String
  },
  data() {
    return {
      active: 0,
      typeList: this.$store.state.butlerTypeList,
      typeName: '',
      progressList: [],
      tabs: [
        {
          title: '处理中'
        },
        {
          title: '已完成'
        },
        {
          title: '无效单'
        },
        {
          title: '全部'
        }
      ],
      columns: [],
      showPicker: false,
      pathDict: {
        "206": '/butler/breakdown/form',
        "207": '/butler/advice/form',
        "208": '/butler/leak/form',
        "209": '/butler/monitor/form',
        "210": '/butler/read/form',
        "407": '/business/checkForm',
      }
    }
  },
  mounted() {
    if (this.$route.query.active) {
      this.active = Number(this.$route.query.active)
    }
    this.getColumns()
    // eslint-disable-next-line no-debugger
    // debugger
    if (this.typeCode) {
      this.typeName = this.getNameByCode(this.typeCode)
    } else {
      if (this.typeList.length > 0) {
        this.typeCode = this.typeList[0].typecode
        this.typeName = this.typeList[0].typename
      }
    }
    this.onChange(this.active)
  },
  // activated() {
  //   // 前进刷新，后退缓存处理
  //   if (this.$route.meta.isUseCache) {
  //     this.$route.meta.isUseCache = false
  //   } else {
  //     if (this.$route.query.active) {
  //       this.active = Number(this.$route.query.active)
  //     }
  //     this.getBusinessTypes()
  //   }
  // },
  beforeRouteLeave(to, from, next) {
    to.meta.isUseCache = true
    next()
  },
  methods: {
    getNameByCode(typeCode) {
      let name = ''
      for (let type of this.typeList) {
        if (type.typecode === typeCode) {
          name = type.typename
          break
        }
      }
      return name
    },
    getColumns() {
      let columns = []
      for (let i = 0; i < this.$store.state.butlerTypeList.length; i++) {
        columns.push(this.$store.state.butlerTypeList[i].typename)
      }
      this.columns = columns
    },
    showClick(progress) {
      this.jumpPage(progress, true)
    },
    rewriteClick(progress) {
      this.jumpPage(progress, false)
    },
    jumpPage(progress, readonly) {
      let path = this.$comm.getTypeDict(progress.busscode).formPath
      this.$router.push({
        path: path,
        query: {
          busscode: progress.busscode,
          bussno: progress.bussno,
          readonly: readonly
        }
      })
    },
    abandonClick(progress) {
      this.$dialog.confirm({
        title: '确认',
        message: '确定放弃本次申请吗？'
      }).then(() => {
        this.$http.post(this.$api.billCancel, {
          busscode: progress.busscode,
          bussno: progress.bussno
        }).then(res => {
          if (res.code === '000') {
            this.$toast('取消成功')
            setTimeout(() => {
              this.getProgressData()
            }, 2000);
          } else {
            this.$toast(res.msg)
          }
        })
      }).catch(() => {
      })
    },
    onConfirm(value) {
      this.typeName = value;
      for (let i = 0; i < this.typeList.length; i++) {
        if (this.typeList[i].typename === value) {
          this.typeCode = this.typeList[i].typecode
        }
      }
      this.showPicker = false;
      this.getProgressData()
    },
    onChange(value) {
      if (value === 0) {
        this.status = 1 // 处理中
      } else if (value === 1) {
        this.status = 2 // 已完成
      } else if (value === 2) {
        this.status = 3 // 无效单
      } else {
        this.status = null // 全部
      }
      this.getProgressData()
    },
    getProgressData() {
      let url = ''
      if (this.typeCode === '210') { // 网上抄表
        url = this.$api.getRead
      } else {
        url = this.$api.butlerProgress
      }
      this.$loading()
      this.$http.post(url, {
        souid: 1, // 业务来源：0-非网厅 1-网厅
        busstype: this.typeCode, // 业务类型
        // bussno: '', // 受理编号
        status: this.status
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.progressList = res.data
        } else {
          this.$toast(res.msg)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.online-progress {
  background: #ffffff;
  .tab-content {
    .progress-info {
      padding: 0 16px;
      margin-top: 17px;
      .info-top-wrapper {
        background: rgba(240, 246, 241, 1);
        border-radius: 3px;
        border: 1px solid rgba(214, 216, 214, 1);
        padding: 10px 12px;
        .info-top {
          display: flex;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(33, 33, 33, 1);
          .info-name {
            width: 70px;
          }
          .info-value {
            width: calc(~"100% - 70px");
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
        }
      }
      .info-bottom-wrapper {
        margin-top: 14px;
        background: rgba(240, 246, 241, 1);
        border-radius: 3px;
        .bottom-title {
          height: 26px;
          line-height: 26px;
          padding: 0 16px;
          background: rgba(240, 246, 241, 1);
          border: 1px solid rgba(214, 216, 214, 1);
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(33, 33, 33, 1);
        }
        .bottom-info {
          display: flex;
          align-items: center;
          padding: 0 16px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(33, 33, 33, 1);
          height: 35px;
          background: #ffffff;
          border-bottom: 1px solid rgba(214, 216, 214, 1);
          border-left: 1px solid rgba(214, 216, 214, 1);
          border-right: 1px solid rgba(214, 216, 214, 1);
          .bottom-name {
            width: 84px;
          }
          .bottom-value {
            width: calc(~"100% - 84px");
            text-align: right;
          }
        }
      }
      .code {
        margin-top: 30px;
        text-align: center;
        .code-img {
          img {
            width: 168px;
            height: 168px;
          }
        }
        .code-txt {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(117, 117, 117, 1);
        }
      }
    }
  }
}
</style>